import { render } from "./ReportDownload.vue?vue&type=template&id=24b84b22&scoped=true"
import script from "./ReportDownload.vue?vue&type=script&lang=js"
export * from "./ReportDownload.vue?vue&type=script&lang=js"

import "./ReportDownload.vue?vue&type=style&index=0&id=24b84b22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b84b22"]])

export default __exports__